import { FilterPoint } from '../types/types';

// Fonction pour calculer le filtre précédent
export const getPrevFilter = (filter: FilterPoint): FilterPoint => {
  const aggregateWindow = filter.aggregateWindow;
  const startDate = filter.startDate || new Date().toISOString();

  if (aggregateWindow === "1h") {
    const startDateObj = new Date(startDate);
    startDateObj.setUTCDate(startDateObj.getUTCDate() - 1);
    startDateObj.setUTCHours(0, 0, 0, 0);
    const stopDateObj = new Date(startDateObj);
    stopDateObj.setUTCDate(stopDateObj.getUTCDate() + 1);
    return { ...filter, startDate: startDateObj.toISOString(), stopDate: stopDateObj.toISOString() };
  }

  if (aggregateWindow === "15m") {
    const startDateObj = new Date(startDate);
    startDateObj.setUTCHours(startDateObj.getUTCHours() - 4);
    startDateObj.setUTCMinutes(0, 0, 0);
    const stopDateObj = new Date(startDateObj);
    stopDateObj.setUTCHours(stopDateObj.getUTCHours() + 4);
    return { ...filter, startDate: startDateObj.toISOString(), stopDate: stopDateObj.toISOString() };
  }

  if (aggregateWindow === "1d") {
    const startDateObj = new Date(startDate);
    startDateObj.setUTCMonth(startDateObj.getUTCMonth() - 1);
    startDateObj.setUTCDate(1);
    startDateObj.setUTCHours(0, 0, 0, 0);
    const stopDateObj = new Date(startDateObj);
    stopDateObj.setUTCMonth(stopDateObj.getUTCMonth() + 1);
    return { ...filter, startDate: startDateObj.toISOString(), stopDate: stopDateObj.toISOString() };
  }

  if (aggregateWindow === "1mo") {
    const startDateObj = new Date(startDate);
    const prevYear = startDateObj.getUTCFullYear() - 1;
    const startDateNormalized = new Date(Date.UTC(prevYear, 0, 1, 0, 0, 0, 0));
    const stopYear = prevYear + 1;
    const stopDateNormalized = new Date(Date.UTC(stopYear, 0, 1, 0, 0, 0, 0));
    return { ...filter, startDate: startDateNormalized.toISOString(), stopDate: stopDateNormalized.toISOString() };
  }

  return filter;
};

// Fonction pour calculer le filtre suivant
export const getNextFilter = (filter: FilterPoint): FilterPoint => {
  const aggregateWindow = filter?.aggregateWindow;
  const stopDate = filter?.stopDate || new Date().toISOString();

  if (aggregateWindow === "1h") {
    const stopDateObj = new Date(stopDate);
    stopDateObj.setUTCDate(stopDateObj.getUTCDate() + 1);
    stopDateObj.setUTCHours(0, 0, 0, 0);
    const startDateObj = new Date(stopDateObj);
    startDateObj.setUTCDate(startDateObj.getUTCDate() - 1);
    return { ...filter, startDate: startDateObj.toISOString(), stopDate: stopDateObj.toISOString() };
  }

  if (aggregateWindow === "15m") {
    const stopDateObj = new Date(stopDate);
    stopDateObj.setUTCHours(stopDateObj.getUTCHours() + 4);
    stopDateObj.setUTCMinutes(0, 0, 0);
    const startDateObj = new Date(stopDateObj);
    startDateObj.setUTCHours(startDateObj.getUTCHours() - 4);
    return { ...filter, startDate: startDateObj.toISOString(), stopDate: stopDateObj.toISOString() };
  }

  if (aggregateWindow === "1d") {
    const stopDateObj = new Date(stopDate);
    stopDateObj.setUTCMonth(stopDateObj.getUTCMonth() + 1);
    stopDateObj.setUTCDate(1);
    stopDateObj.setUTCHours(0, 0, 0, 0);
    const startDateObj = new Date(stopDateObj);
    startDateObj.setUTCMonth(startDateObj.getUTCMonth() - 1);
    return { ...filter, startDate: startDateObj.toISOString(), stopDate: stopDateObj.toISOString() };
  }

  if (aggregateWindow === "1mo") {
    const stopDateObj = new Date(stopDate);
    const nextYear = stopDateObj.getUTCFullYear() + 1;
    const stopDateNormalized = new Date(Date.UTC(nextYear, 0, 1, 0, 0, 0, 0));
    const startYear = nextYear - 1;
    const startDateNormalized = new Date(Date.UTC(startYear, 0, 1, 0, 0, 0, 0));
    return { ...filter, startDate: startDateNormalized.toISOString(), stopDate: stopDateNormalized.toISOString() };
  }

  return filter;
};

